export const MAX_EMPTY_ANSWERS = 4 as number;
export const SINGLE_ANSWER = 1 as number;
export const INITIAL_ANSWER_POSITION = 0 as number;
export const ONE_ANSWER_POSITION = 1 as number;
